import React, { useEffect, useState } from "react";
import { Badge, Col, Form, Offcanvas, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";
import { eiwrsSiteInventoryServices } from "../../../../APIServices/EIWRS/eiwrsSiteInventoryServices";
import { eiwrsKitMetadataServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";

const UpdateStudyKitPreparation = ({
  kitData,
  getStudyKitPreparationData,
  Show,
  Hide,
  Title,
  depotList,
  treatmentList,
  kitTypeList,
  setKitId,
  kitBatchList
}) => {
  const { studyId } = useParams()
  const [depotId, setDepotId] = useState("");
  const [kitType, setKitType] = useState("");
  const [treatmentId, setTreatmentId] = useState("");
  const [batchNumber, setBatchNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [columns, setColumns] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const updateStudyKitPreparation = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Study Site Kit!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitData?._id;
        userData.studyId = studyId;
        userData.depotId = depotId;
        userData.kitType = kitType;
        userData.treatmentId = treatmentId;
        userData.batchNumber = batchNumber;
        userData.expiryDate = expiryDate;
        userData.columns = columns;
        userData.mode = StudyMode;
        let data = await eiwrsKitPreparationServices.updateStudyKitPreparation(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyKitPreparationData();
          Hide();
        }
      }
      setButtonLoader(false);
    });
  };

  const getEIWRSKitMetadataData = async (e) => {
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "active",
      studyId,
    );
    let responseData = (data?.data || []).map(item => {
      return {
        columnId: item?.columnId,
        columnLabel: item?.columnLabel,
        columnName: item?.columnName,
        columnType: item?.columnType,
        isUnique: item?.isUnique,
        columnValue: "",
      };
    });
    const result = responseData.map((item) => {
      const responseColumn = (kitData?.columns || []).find(
        (response) => response.columnId === item.columnId
      );

      return {
        ...item,
        columnValue: responseColumn?.columnValue || ""
      };
    });
    setColumns(result);
  };

  const updateColumn = (columnId, field, value) => {
    setColumns((prev) =>
      prev.map((column) =>
        column.columnId === columnId
          ? {
            ...column,
            [field]: value,
          }
          : column
      )
    );
  };

  useEffect(() => {
    setDepotId(kitData?.depotId);
    setKitType(kitData?.kitType);
    setTreatmentId(kitData?.treatmentId);
    setBatchNumber(kitData?.batchNumber);
    setExpiryDate(kitData?.expiryDate);
    getEIWRSKitMetadataData()
  }, [kitData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Depot <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={depotId}
              disabled={depotList?.length === 0}
              onChange={(e) => setDepotId(e.target.value)}
            >
              <option value="">
                Select Depot
              </option>
              {depotList?.map((item, index) => (
                <option key={index} value={item.depotId}>
                  {item.row?.DEPOTID}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Kit Type <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={kitType}
              onChange={(e) => setKitType(e.target.value)}
            >
              <option value="">
                Select Kit Type
              </option>
              {kitTypeList?.map((item, index) => (
                <option key={index} value={item.type}>
                  {item.type}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Treatment <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={treatmentId}
              onChange={(e) => setTreatmentId(e.target.value)}
            >
              <option value="">
                Select Treatment
              </option>
              {treatmentList?.map((item, index) => (
                <option key={index} value={item.treatmentId}>
                  {item.row?.TREATMENTID}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Batch Number <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={batchNumber}
              onChange={(e) => setBatchNumber(e.target.value)}
            >
              <option value="">
                Select Batch Number
              </option>
              {kitBatchList?.map((item, index) => (
                <option key={index} value={item.batchNumber}>
                  {item.batchNumber}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Expiry Date <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setExpiryDate(e.target.value)}
              value={expiryDate}
              className="br3"
              type="date"
            />
          </Form.Group>
          <div className="mt-3">
            {columns?.map((column, index) => (
              <div
                key={column.columnId}
                className="border rounded p-2 mb-2"
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <strong style={{ fontSize: 12 }}>{column.columnLabel} ({column.columnName})</strong>
                  <Badge
                    bg="primary-subtle"
                    style={{ fontSize: 10 }}
                    className={`CP text-capitalize br3 text-primary border-primary border px-2 text-capitalize mx-2`}
                  >
                    Unique: {column.isUnique}
                  </Badge>
                </div>
                <Form.Control
                  type={column.columnType}
                  placeholder="Enter Column Value"
                  value={column.columnValue}
                  disabled={!column.columnType}
                  onChange={(e) =>
                    updateColumn(
                      column.columnId,
                      "columnValue",
                      e.target.value
                    )
                  }
                />
              </div>
            ))}
          </div>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!depotId || !treatmentId || !kitType || !batchNumber || !expiryDate || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateStudyKitPreparation(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Kit"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyKitPreparation;
